import { Switch } from "react-router-dom";

import MiddlewareRoute from "../Middleware";

import { OfxConversor } from "../../pages/ofxConversor/OfxConversor";

export default function OfxConversorModule() {
  return (
    <Switch>
      <MiddlewareRoute
        path="/extrato-facil"
        sidebar
        component={OfxConversor}
        noPaddingSidebar
      />
    </Switch>
  );
}
